export const DELIVERY_REQUESTED = "DELIVERY_REQUESTED";
export const DELIVERY_RECEIVED = "DELIVERY_RECEIVED";
export const DELIVERY_REQUEST_FAILED = "DELIVERY_REQUEST_FAILED";

export const requestOrderDeliveryDates = orderCode => ({ type: DELIVERY_REQUESTED, id: orderCode });

export const receiveOrderDelivery = (orderCode, delivery) => ({
  type: DELIVERY_RECEIVED,
  id: orderCode,
  payload: delivery
});
